"use client";
import Link from "next/link";
import { ArrowRight, Cpu, BookOpen, TrendingUp } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whatWeDo as data } from "@/lib/data/careers";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = { Cpu, BookOpen, TrendingUp };
const accentMap: Record<string, string> = {
  "The Platform": "var(--color-crimson)",
  "The Technology": "var(--color-cyan)",
  "The Impact": "var(--color-emerald)",
};

export function WhatWeDo() {
  return (
    <Section id="what-we-do" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-3 gap-5">
          {data.pillars?.map((p, i) => {
            const Icon = iconMap[Object.keys(iconMap)[i] || "Cpu"] ?? Cpu;
            const accent = accentMap[p.title] ?? "var(--color-crimson)";
            return (
              <Reveal key={p.title} delay={i * 100}>
                <div className="glass rounded-2xl p-7 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <span className="grid place-items-center h-12 w-12 rounded-2xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                    <Icon className="h-5 w-5" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-5">{p.title}</h3>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{p.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
